import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await register(form.name, form.email, form.password);
    setBusy(false);
    if (r.ok) {
      toast.success("Account created");
      nav("/account");
    } else {
      toast.error(r.error);
    }
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="min-h-screen pt-32 pb-24 flex items-start justify-center px-6" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#C85A32] mb-4">Account</div>
        <h1 className="font-serif-display text-5xl font-light mb-8">Join the estate.</h1>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Name">
            <input
              data-testid="register-name"
              value={form.name}
              onChange={set("name")}
              required
              className="w-full bg-transparent border border-[#EBE3D5] px-4 py-3 focus:border-[#1C3326] focus:outline-none"
            />
          </Field>
          <Field label="Email">
            <input
              data-testid="register-email"
              type="email"
              value={form.email}
              onChange={set("email")}
              required
              className="w-full bg-transparent border border-[#EBE3D5] px-4 py-3 focus:border-[#1C3326] focus:outline-none"
            />
          </Field>
          <Field label="Password">
            <input
              data-testid="register-password"
              type="password"
              minLength={6}
              value={form.password}
              onChange={set("password")}
              required
              className="w-full bg-transparent border border-[#EBE3D5] px-4 py-3 focus:border-[#1C3326] focus:outline-none"
            />
          </Field>
          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit"
            className="w-full bg-[#1C3326] hover:bg-[#15261C] text-[#FDFBF7] py-4 uppercase text-xs tracking-[0.3em] font-medium transition-colors disabled:opacity-60"
          >
            {busy ? "Creating…" : "Create Account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#7B6F66]">
          Already have an account?{" "}
          <Link to="/login" className="link-underline text-[#1C3326]" data-testid="link-login">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-xs uppercase tracking-[0.15em] text-[#7B6F66] mb-2">{label}</div>
      {children}
    </label>
  );
}
